import React, { useState, useEffect } from 'react';
import { Input, Modal, List, message } from 'antd';
import { SwapOutlined, SearchOutlined, AppstoreAddOutlined } from '@ant-design/icons';
import { safeNavigate, SafeStorage } from '../../utils/jsbridge';

const accId = window.__baseInfo.accId;

const SwitchShop = (props) => {
    const [shops, setShops] = React.useState([]);
    const [filteredShops, setFilteredShops] = React.useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const { title = '', onSwitch, children } = props;
    const [currentShop, setCurrentShop] = useState(null);

    // 初始化时获取当前店铺信息
    useEffect(() => {
        const initCurrentShop = async () => {
            try {
                let storedShop = await SafeStorage.getItem('currentShop');
                storedShop = storedShop ? JSON.parse(storedShop)[accId] : null;
                console.log('storedShop', storedShop);
                setCurrentShop(storedShop);
                
                if (!storedShop) setIsOpen(true);
            } catch (error) {
                console.log(error);
                setIsOpen(true);
            }
        };
        
        initCurrentShop();
    }, []);

    // 同步状态与参数 
    useEffect(() => {
        getShops();
    }, []);

    // 搜索过滤
    useEffect(() => {
        if (searchText.trim()) {
            const filtered = shops.filter(shop => 
                shop.title?.toLowerCase().includes(searchText.toLowerCase())
            );
            setFilteredShops(filtered);
        } else {
            setFilteredShops(shops);
        }
    }, [searchText, shops]);

    const getShops = async () => {
        try {
            let response = await fetch(`/api/shop/my-permission-list?accId=${accId}`);
            let result = await response.json();

            if(result && result.success) {
                setShops(result.data);
                setFilteredShops(result.data);
                SwitchShop.shops = result.data;
            }
        } catch (error) {
            message.error('获取店铺列表失败');
        }
    }

    const switchShop = () => {
        console.log('切换店铺');
        setIsOpen(true);
    }

    // 店铺切换处理器 
    const handleShopSwitch = async (shop) => {
        try {
            const newUrl = new URL(window.location.href); 
            newUrl.searchParams.set('shopId', shop.shopId); 
            
            await SafeStorage.setItem('currentShop', JSON.stringify({[accId]: shop})); 
            setCurrentShop(shop);
            
            window.dispatchEvent(new Event('shopSwitch'));
            
            message.success(`已切换到 ${shop.title}`);
            setIsOpen(false);
            
            safeNavigate(newUrl.toString());
        } catch (error) {
            message.error('切换店铺失败');
        }
    };

    return (
        <>
            {/* 触发器 */}
            <div 
                onClick={switchShop}
                className="flex items-center justify-between px-3 py-2.5 bg-white border border-gray-200 rounded-lg cursor-pointer active:scale-[0.98] hover:border-blue-300 transition-all shadow-sm"
            >
                <div className="min-w-0 flex-1">
                    <div className="text-sm font-semibold text-gray-800 truncate">
                        {currentShop ? (currentShop.title || '未选择店铺') : '点击选择店铺'}
                    </div>
                </div>
                {children ? children : (
                    <span className="text-blue-600 flex items-center gap-1 flex-shrink-0 ml-2">
                        <SwapOutlined className="text-base" />
                    </span>
                )}
            </div>

            {/* 店铺选择弹窗 */}
            <Modal
                title="选择店铺"
                open={isOpen}
                footer={null}
                centered
                width="90%"
                style={{ maxWidth: '400px' }}
                onCancel={() => setIsOpen(false)}
                className="mobile-shop-switch"
                bodyStyle={{ padding: 0 }}
            >
                <div className="flex flex-col" style={{ maxHeight: '60vh' }}>
                    {/* 搜索框 */}
                    <div className="p-3 border-b border-gray-100">
                        <Input.Search
                            placeholder="搜索店铺名称"
                            prefix={<SearchOutlined className="text-gray-400" />}
                            allowClear
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-full"
                            size="large"
                        />
                    </div>

                    {/* 店铺列表 */}
                    <div className="flex-1 overflow-y-auto" style={{ maxHeight: 'calc(60vh - 70px)' }}>
                        {filteredShops.length === 0 ? (
                            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
                                <AppstoreAddOutlined className="text-4xl mb-2" />
                                <div className="text-sm">
                                    {searchText ? '未找到匹配的店铺' : '暂无可用店铺'}
                                </div>
                            </div>
                        ) : (
                            <List
                                dataSource={filteredShops}
                                renderItem={(item) => (
                                    <List.Item
                                        onClick={() => handleShopSwitch(item)}
                                        className="cursor-pointer active:bg-blue-50 hover:bg-gray-50 transition-colors px-4 py-3 border-b border-gray-50 last:border-b-0"
                                        actions={[
                                            item.shopId === currentShop?.shopId ? (
                                                <span className="text-green-600 text-xs font-medium">当前</span>
                                            ) : (
                                                <span className="text-blue-600 text-xs">选择</span>
                                            )
                                        ]}
                                    >
                                        <div className="flex-1 min-w-0">
                                            <div className="text-sm font-medium text-gray-800 truncate">
                                                {item.title}
                                            </div>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        )}
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default SwitchShop;